import { Injectable } from '@angular/core';
import { Observable, catchError, map, retry } from 'rxjs';
import { IMyChainstoreRender } from '../../../models';
import { DataProvider } from '../../basic/data.service';

@Injectable({
  providedIn: 'root'
})
export class MyChainstoreProvider extends DataProvider<any> {
  // Properties & Signals
  override endpoint = 'f/components/mychainstore';

  // Methods
  /**
   * Loads the chainstore the visitor currently has selected.
   * @returns The render payload holding the selected chainstore, empty while none is chosen
   */
  getCurrent(): Observable<IMyChainstoreRender> {
    return this.http
      .get<IMyChainstoreRender>(this.endpointWithUrl, this.httpOptions)
      .pipe(map((data) => DataProvider.mapCasesReverse(data)))
      .pipe(retry(1), catchError(this.errorService.convert));
  }

  /**
   * Stores the given chainstore as the visitor's preferred one. The backend answers with the
   * `gs.ocs.mychainstore` header, which the auth interceptor persists as a cookie.
   * @param chainStoreID The chainstore to select
   * @returns The render payload holding the now selected chainstore
   */
  set(chainStoreID: number): Observable<IMyChainstoreRender> {
    return this.http
      .post<IMyChainstoreRender>(`${this.endpointWithUrl}/set/${chainStoreID}`, {}, this.httpOptions)
      .pipe(map((data) => DataProvider.mapCasesReverse(data)))
      .pipe(catchError(this.errorService.convert));
  }
}
